import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../private/shared/modules/shared.module';
import { AddProductsButtonsComponent } from './add-products-buttons/add-products-buttons.component';
import { HeaderLevelComponent } from './header-level/header-level.component';
import { HowManyRedeemComponent } from './how-many-redeem/how-many-redeem.component';
import { ProductsLevelComponent } from './products-level/products-level.component';
import { PromoDetailPage } from './promo-detail.page';
import { PromoStatusComponent } from './promo-status/promo-status.component';
import { RowProductComponent } from './row-product/row-product.component';
import { SummaryComponent } from './summary/summary.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
  ],
  declarations: [
    PromoDetailPage,
    HeaderLevelComponent,
    RowProductComponent,
    ProductsLevelComponent,
    HowManyRedeemComponent,
    PromoStatusComponent,
    SummaryComponent,
    AddProductsButtonsComponent,
  ]
})
export class PromoDetailPageModule {}
